export const generateTextImportItems = () => {
    const templateMenuItems = [
        {
            name: 'Plain Text Analysis',
            img: 'app-notes',
            type: 'textEditor',
            category: ['popular', 'analysis', 'all-use-cases'],
            textInput: [
                'all',
                'long',
                'popular',
                'text',
                'allShortText',
                'allAi',
                'allMarketing',
            ],
            description: `Reveal the main topics, ideas, and gaps in a text, find what's missing`,
        },

        {
            name: 'Google Search Results',
            img: 'app-google-search',
            category: ['google', 'seo', 'import'],
            type: 'google',
            description:
                'Visualize the main topics and gaps in Google search results',
            // url: `/import/google`,
            textInput: [
                'web',
                'webAi',
                'popular',
                'popularAi',
                'short',
                'keywords',
                'supply',
                'googleSearch',
                'allShortText',
                'allAi',
                'allMarketing',
            ],
        },

        {
            name: 'Google Search Results',
            img: 'app-google-search',
            category: ['marketingSelected'],
            textInput: ['marketingSelected', 'allMarketing'],
            type: 'google',
            description:
                'Visualize the main topics and gaps in Google search results',
        },

        {
            name: 'Topical Clusters for SEO',
            img: 'app-google',
            category: ['marketingSelected'],
            textInput: ['marketingSelected', 'allMarketing'],
            type: 'google',
            description:
                'Visualize the main topical clusters for Google results',
        },

        {
            name: 'Search Intent Keywords',
            img: 'app-keywords',
            type: 'keywords',
            category: ['marketingSelected'],
            textInput: ['marketingSelected', 'googleKeywords', 'allMarketing'],
            description:
                'Discover related search patterns to understand the demand',
        },
        {
            name: 'Search Intent Keywords',
            img: 'app-keywords',
            type: 'keywords',
            category: [
                'seo',
                'google',
                'import',
                'recommended',
                'all-use-cases',
            ],
            textInput: ['keywords', 'seo', 'allMarketing'],
            description: 'Reveal the search patterns related to a search query',
        },

        {
            name: 'What People Search For',
            img: 'app-related-queries', // app-keywords
            type: 'keywords',
            category: [
                'seo',
                'google',
                'import',
                'recommended',
                'all-use-cases',
            ],
            textInput: [
                'web',
                'webAi',
                'short',
                'demand',
                'popular',
                'allAi',
                'allShortText',
                'popularSearchQueries',
                'allMarketing',
            ],
            description:
                'Find the keywords related to a specific search query to understand the demand',
        },

        {
            name: 'Google Scholar Snippets',
            img: 'app-scholar',
            type: 'scholar',
            category: ['science', 'scholar', 'google', 'import', 'marketing'],
            description:
                'Analyze top Google Scholar search results for your query',
            url: `/import/scholar`,
            textInput: [
                'web',
                'webAi',
                'popularAi',
                'short',
                'supply',
                'googleScholar',
                'allShortText',
                'allAi',
                'allMarketing',
            ],
        },
        {
            name: 'Google Patents Analysis',
            img: 'app-patents',
            type: 'patents',
            category: [
                'science',
                'googlePatents',
                'google',
                'import',
                'marketing',
            ],
            description: 'Analyze Patents search results for your query',
            url: `/import/patents`,
            textInput: [
                'web',
                'webAi',
                'popularAi',
                'short',
                'supply',
                'googlePatents',
                'allShortText',
                'allAi',
                'allMarketing',
            ],
        },
        {
            name: 'Websites, Web Pages & URLs',
            img: 'app-link',
            type: 'urls',
            category: [
                'popular',
                'seo',
                'news',
                'marketing',
                'import',
                'urls',
                'all-use-cases',
            ],
            description:
                'Extract the main ideas and gaps from web pages or a whole website',
            url: `/import/url`,
            textInput: [
                'urls',
                'popular',
                'web',
                'webAi',
                'allLinks',
                'supply',
                'allShortText',
                'allMarketing',
            ],
        },
        {
            name: 'Analyze Competitor Websites',
            img: 'app-link',
            type: 'urls',
            category: ['marketingSelected'],
            textInput: ['marketingSelected', 'allMarketing'],

            description: 'Learn how your competitors talk about themselves',
            url: `/import/url`,
        },
        {
            name: 'How LLM Sees a Topic (Overview)',
            img: 'app-kg',
            type: 'aiTopics',
            category: [
                'popular',
                'kgs',
                'ideation',
                'analysis',
                'seo',
                'play',
                'import',
                'ai',
                'all-use-cases',
            ],
            textInput: [
                'kgs',
                'ai',
                'short',
                'keywords',
                'aiTopics',
                'allShortText',
                'aiKgs',
                'allAi',
            ],
            description: 'Discover how AI sees a certain topic or domain',
        },
        {
            name: 'How LLM Sees a Topic',
            img: 'app-kg',
            type: 'aiTopicsLlm',
            category: [
                'popular',
                'ideation',
                'analysis',
                'seo',
                'play',
                'import',
                'all-use-cases',
            ],
            textInput: [
                'short',
                'keywords',
                'marketingSelected',
                'supply',
                'allMarketing',
            ],
            description: 'Visualize the main topical clusters in a domain',
        },
        {
            name: 'Ontology Graph (LLM Generated)',
            img: 'app-ontologies',
            type: 'aiOntologies',
            category: [
                'popular',
                'kgs',
                'ideation',
                'analysis',
                'seo',
                'play',
                'import',
                'ai',
                'all-use-cases',
            ],
            textInput: [
                'popularAi',
                'kgs',
                'ai',
                'short',
                'keywords',
                'aiOntologies',
                'supply',
                'allShortText',
                'allAi',
                'aiKgs',
                'allMarketing',
            ],
            description:
                'Use Ai to generate a knowledge graph / ontology for any topic',
        },
        {
            name: 'Knowledge Graph (LLM Generated)',
            img: 'app-ai-graph',
            type: 'aiGraphs',
            category: [
                'popular',
                'kgs',
                'ideation',
                'analysis',
                'seo',
                'play',
                'import',
                'ai',
                'all-use-cases',
            ],
            textInput: [
                'popular',
                'kgs',
                'ai',
                'short',
                'keywords',
                'aiGraphs',
                'supply',
                'allShortText',
                'allAi',
                'aiKgs',
                'allMarketing',
            ],
            description:
                'Use Ai to generate a knowledge graph / ontology for any topic',
        },
        {
            name: 'Step-by-Step AI Ideation',
            img: 'app-insight',
            type: 'aiIdea',
            category: ['ideation', 'notes', 'recommended', 'all-use-cases'],
            description:
                'Best for brainstorming ideas about a topic using AI. Add best ideas to the graph',
            textInput: [
                'ai',
                'short',
                'keywords',
                'aiIdea',
                'allShortText',
                'allAi',
            ],
        },
        {
            name: 'Live AI Graph Chat Mode',
            img: 'app-chatgpt',
            type: 'aiChat',
            category: [
                'ideation',
                'popular',
                'creative',
                'play',
                'new',
                'ai',
                'all-use-cases',
                'import',
            ],
            description:
                'AI chatbot with a live graph of the main topics, gaps, and ideas',
            textInput: [
                'ai',
                'short',
                'keywords',
                'aiChat',
                'allShortText',
                'allAi',
            ],
        },
        {
            name: 'Create a Mindmap from Text',
            img: 'app-mindmap',
            type: 'mindmapImport',
            category: ['popular', 'analysis', 'mindmapping', 'all-use-cases'],
            textInput: ['all', 'long', 'mindmapping', 'allShortText', 'allAi'],
            description: 'Create a mind map from plain text or [[backlinks]]',
        },
        {
            name: 'Knowledge Graph with [[Wiki Links]]',
            img: 'app-graph',
            type: 'pkmImport',
            category: ['analysis', 'mindmapping', 'kgs', 'all-use-cases'],
            textInput: [
                'all',
                'long',
                'mindmapping',
                'kgs',
                'allShortText',
                'allAi',
                'aiKgs',
                'pkmImport',
            ],
            description: 'Create a knowledge graph with [[wiki links]]',
        },
        {
            name: 'Scientific Database Results',
            img: 'app-science',
            type: 'science',
            category: ['science', 'import', 'marketing'],
            description:
                'Import scientific papers titles and abstracts from scientific publications',
            url: `/import/science`,
            textInput: [
                'web',
                'short',
                'science',
                'allShortText',
                'webAi',
                'allAi',
            ],
        },
        {
            name: 'X (Twitter) Content & Topics',
            img: 'app-x',
            type: 'twitter',
            category: ['twitter', 'import', 'recommended', 'all-use-cases'],
            textInput: [
                'short',
                'keywords',
                'supply',
                'twitterSearch',
                'allShortText',
                'allAi',
                'socialAi',
                'social',
                'allMarketing',
            ],
            description:
                'Find what else people are tweeting about when they tweet about a certain topic',
        },
        {
            name: 'Search Engine Optimization',
            img: 'app-seo',
            type: 'seo',
            category: ['seo', 'all-use-cases'],
            description:
                'Build a graph of what people search for and what they find on Google',
            textInput: [
                // 'web',
                'short',
                'keywords',
                'seo',
                'comparative',
                // 'allShortText',
                'allMarketing',
            ],
        },
        {
            name: 'Demand vs Supply',
            img: 'app-niche',
            type: 'niche',
            category: ['marketing', 'recommended', 'all-use-cases'],
            description:
                'Find what people search for but do not yet find on Google',
            textInput: [
                // 'web',
                'short',
                'keywords',
                'niche',
                'comparative',
                // 'allShortText',
                'allMarketing',
            ],
        },

        {
            name: 'Qualitative Analysis',
            img: 'app-surveys',
            type: 'qualitativeImport',
            category: ['marketing', 'popular', 'qualitative', 'all-use-cases'],
            textInput: ['plain', 'allMarketing', 'demand'],
            description:
                'Discover recurrent themes and gaps in a survey or customer reviews',
        },

        {
            name: 'Customer Reviews & Surveys',
            img: 'app-surveys',
            type: 'qualitativeImport',
            category: ['marketingSelected'],
            textInput: ['marketingSelected', 'allMarketing'],
            description:
                'What are the positive / negative things customers say',
        },

        {
            name: 'RSS Feeds & Blogs',
            img: 'app-rss',
            type: 'rss',
            category: ['rss', 'news'],
            textInput: [
                'rss',
                'allLinks',
                'allMarketing',
                'allAi',
                'externalAi',
            ],
            description:
                'Find recurrent topics and gaps in RSS feeds (e.g. blogs, Reddit)',
        },
        {
            name: 'News Websites',
            img: 'app-preselected',
            type: 'news',
            category: ['rss', 'news'],
            textInput: [
                'rss',
                'allLinks',
                'allMarketing',
                'allAi',
                'externalAi',
            ],
            description: `See the picture of the day from multiple news sources, find what's missing`,
        },
        {
            name: 'Amazon Product Reviews',
            img: 'app-amazon',
            type: 'amazonReviews',
            category: [
                'marketing',
                'qualitative',
                'amazon',
                'import',
                'all-use-cases',
            ],
            description:
                'Extract the main topics in positive and negative Amazon reviews',
            url: `/import/amazon`,
            textInput: [
                'amazonReviews',
                'asin',
                'allLinks',
                'marketing',
                'demand',
                'products',
                'allMarketing',
            ],
        },
        {
            name: 'Amazon Search Keywords',
            img: 'app-amazon',
            type: 'amazonProducts',
            category: ['seo', 'marketing', 'amazon', 'import', 'all-use-cases'],
            description: 'Uncover the main topics in Amazon product listings',
            url: `/import/amazon-keywords`,
            textInput: [
                'short',
                'keywords',
                'amazonProducts',
                'seo',
                'products',
                'allMarketing',
            ],
        },
        {
            name: 'Amazon Search Results',
            img: 'app-amazon',
            type: 'amazonProducts',
            category: ['seo', 'marketing', 'amazon', 'import', 'all-use-cases'],
            description:
                'Extract main keyword combinations in Amazon search results',
            url: `/import/amazon-keywords`,
            textInput: ['web', 'allShortText', 'supply', 'allMarketing'],
        },
        {
            name: 'YouTube Search Results',
            img: 'app-youtube',
            type: 'youtubeVideos',
            category: ['google', 'import', 'marketing', 'seo', 'all-use-cases'],
            description:
                'Extract main keyword combinations in YouTube search results',
            url: '/import/youtube',
            textInput: [
                'web',
                'webAi',
                'popularAi',
                'short',
                'allShortText',
                'youtubeVideos',
                'allAi',
            ],
        },
        {
            name: 'YouTube Search Results',
            img: 'app-youtube',
            type: 'youtubeKeywords',
            category: ['google', 'import', 'marketing', 'seo', 'all-use-cases'],
            description:
                'Extract main keyword combinations in YouTube search results',
            url: '/import/youtube',
            textInput: [
                'keywords',
                'supply',
                'youtubeKeywords',
                'seo',
                'allMarketing',
            ],
        },
        {
            name: 'YouTube Video Comments',
            img: 'app-youtube',
            type: 'youtubeComments',
            category: [
                'google',
                'marketing',
                'qualitative',
                'import',
                'all-use-cases',
            ],
            description: 'Extract the main topics from YouTube video comments',
            url: '/import/youtube-comments',
            textInput: [
                'youtubeComments',
                'allLinks',
                'marketing',
                'social',
                'socialAi',
                'demand',
                'allMarketing',
            ],
        },
        {
            name: 'YouTube Video Subtitles',
            img: 'app-youtube',
            type: 'youtubeSubtitles',
            category: [
                'google',
                'marketing',
                'qualitative',
                'import',
                'all-use-cases',
            ],
            description: 'Retrieve the main topics from a YouTube video',
            url: '/import/youtube-subtitles',
            textInput: [
                'youtubeSubtitles',
                'allLinks',
                'marketing',
                'allMarketing',
                'allAi',
                'social',
                'socialAi',
                'allShortText',
            ],
        },
        {
            name: 'YouTube Channels & Playlists',
            img: 'app-youtube',
            type: 'youtubeChannel',
            category: ['google', 'marketing', 'import', 'seo', 'all-use-cases'],
            description:
                'Extract the main ideas from a YouTube channel or playlist',
            url: '/import/youtube-comments',
            textInput: [
                'youtubeChannel',
                'allLinks',
                'marketing',
                'social',
                'socialAi',
                'supply',
                'allShortText',
                'allMarketing',
            ],
        },
        {
            name: 'Wikipedia',
            img: 'app-wiki',
            description: 'Get an overview of Wikipedia pages',
            url: `/import/wiki`,
            textInput: ['wiki'],
        },
        {
            name: 'Evernote Notes Content',
            img: 'app-evernote',
            type: 'evernote',
            category: ['notes', 'pkm', 'note-tools', 'import', 'all-use-cases'],
            description:
                'Extract the main ideas and find gaps in any Evernote notes folder',
            url: `/import/evernote`,
            textInput: ['allAi', 'allShortText', 'externalAi'],
        },
        {
            name: 'PDF / TXT Files Analysis',
            img: 'app-import',
            type: 'textFilesImport',
            category: ['files', 'popular', 'analysis', 'import'],
            description:
                'Extract the main ideas from a PDF or a TXT document or an article',
            url: `/import/files`,
            textInput: ['files', 'allAi', 'allShortText'],
        },
        {
            name: 'Corporate Reports',
            img: 'app-import',
            type: 'textFilesImport',
            category: ['files', 'popular', 'analysis', 'import'],
            description:
                'Extract the main ideas and find gaps in a corporate report',
            url: `/import/files`,
            textInput: ['supply', 'allMarketing'],
        },
        {
            name: 'CSV Spreadsheets',
            img: 'app-csv',
            type: 'csvFileImport',
            category: [
                'files',
                'seo',
                'marketing',
                'analysis',
                'qualitative',
                'import',
                'new',
                'recommended',
            ],
            description:
                'Extract the main ideas and find gaps in a CSV / spreadsheet column, add filters',
            url: `/import/csv`,
            textInput: [
                'files',
                'marketing',
                'allMarketing',
                'allAi',
                'allShortText',
            ],
        },
        {
            name: 'JSON Files',
            img: 'app-json',
            type: 'jsonFileImport',
            category: [
                'files',
                'popular',
                'seo',
                'marketing',
                'analysis',
                'qualitative',
                'import',
                'new',
                'recommended',
            ],
            description:
                'Extract the main ideas and find gaps in a JSON file, add filters',
            url: `/import/json`,
            textInput: [
                'files',
                'marketing',
                'allMarketing',
                'allAi',
                'allShortText',
            ],
        },
        {
            name: 'NetworkX / Graphify',
            img: 'app-graph',
            type: 'networkxFileImport',
            category: ['files', 'analysis', 'kgs', 'import'],
            description:
                'Visualize a NetworkX node-link JSON graph, e.g. from Graphify',
            url: `/import/networkx`,
            textInput: ['files', 'allShortText'],
        },
        {
            name: 'Markdown Files',
            img: 'app-obsidian',
            category: [
                'files',
                'notes',
                'pkm',
                'note-tools',
                'import',
                'all-use-cases',
            ],
            type: 'mdFilesImport',
            description:
                'Extract the main ideas and gaps from a markdown (Obsidian) document',
            url: `/import/markup`,
            textInput: ['files', 'allAi', 'aiKgs', 'allShortText'],
        },
        {
            name: 'Other Sources',
            img: 'app-alltext',
            category: ['import'],
            type: 'shortTextImport',
            description: 'Click to view other import sources',
            // url: `/import/google`,
            textInput: ['backLink'],
        },
        {
            name: 'Other Sources',
            img: 'app-alltext',
            category: ['import'],
            type: 'aiImport',
            description: 'Click to view other import sources',
            // url: `/import/google`,
            textInput: ['backLinkToAi'],
        },
        {
            name: 'Other Sources',
            img: 'app-alltext',
            category: ['import'],
            type: 'marketImport',
            description: 'Click to view other import sources',
            // url: `/import/google`,
            textInput: ['backLinkToMarket'],
        },
        {
            name: 'Other Sources',
            img: 'app-alltext',
            type: 'linkImport',
            description: 'Click to view other import sources',
            // url: `/import/google`,
            textInput: ['backLinkToLinks'],
        },
    ]
    return templateMenuItems
}
